const imagePutOperation = (storageRef, file, successFunc, failedFunc) => {
    const task = storageRef.put(file);
    task.on('state_changed', (snapshot) => {

    }, (e) => {
        console.log(e);
        if(failedFunc) failedFunc(e);
    }, () =>{
        if(successFunc) successFunc();
    })
};
const imagePutOperationIndex = (storageRef, file, successFunc, failedFunc, index) => {
    const task = storageRef.put(file);
    task.on('state_changed', (snapshot) => {

    }, (e) => {
        console.log(e);
        if(failedFunc) failedFunc(e);
    }, () =>{
        if(successFunc) successFunc(index);
    })
};


export const loadImage = (storagePath, id, subfix, beforeLoadFunc, successFunc, failedFunc) => {
    return (dispatch, getState, getFirebase) =>{

        if(beforeLoadFunc) beforeLoadFunc();  

        const firebase = getFirebase();
        firebase.storage().ref(`${storagePath}/${id}${subfix}.jpg`).getDownloadURL()
            .then((url) => {
                if(successFunc) successFunc(url); 
            })
            .catch((e) => {
                if(failedFunc) failedFunc(e);
            })
    }
}

export const deleteImage = (storagePath, id, successFunc, failedFunc) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const imageRef = firebase.storage().ref(`${storagePath}/${id}.jpg`);
        imageRef.delete()
            .then(() => {
                if(successFunc) successFunc();
            })
            .catch((e) => {
                if(failedFunc) failedFunc();
            })
    }
}

export const updateImage = (storagePath, id, subfix, file, beforeUpdateFunc, successFunc, failedFunc) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();
        const subfixPath = subfix ? `_${subfix}` : '';

        if(beforeUpdateFunc) beforeUpdateFunc();

        const imageRef = firebase.storage().ref(`${storagePath}/${id}${subfixPath}.jpg`);    
        imageRef.delete()
            .then(() => {
                imagePutOperation(imageRef, file, successFunc, failedFunc);
            })
            .catch((e) => {
                imagePutOperation(imageRef, file, successFunc, failedFunc);
            })
    }
}

export const updateImages = (storagePath, id, files, prevCount, beforeUpdateFunc, successFunc, failedFunc) => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase();

        if(beforeUpdateFunc) beforeUpdateFunc();

        if(files.length > prevCount) {
            for(let i = 0; i < files.length; ++i) {
                const imageRef = firebase.storage().ref(`${storagePath}/${id}_${i}.jpg`);
                imageRef.delete()
                    .then(() => {
                        imagePutOperationIndex(imageRef, files[i], successFunc, failedFunc, i);
                    })
                    .catch((e) => {
                        imagePutOperationIndex(imageRef, files[i], successFunc, failedFunc, i); 
                    })
            }
        }
        else {
            for(let i = 0; i < prevCount; ++i) {
                const imageRef = firebase.storage().ref(`${storagePath}/${id}_${i}.jpg`);
                console.log(prevCount);
                imageRef.delete()
                    .then(() => {
                        if(i < files.length){
                            imagePutOperationIndex(imageRef, files[i], successFunc, failedFunc, i);
                        }
                    })
                    .catch((e) => {
                        console.log(e);
                        if(i < files.length) {
                            imagePutOperationIndex(imageRef, files[i], successFunc, failedFunc, i);
                        }
                    })
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/Admin/actions/imageActions.js